import React from 'react';
import './animatedbackground.css';

const AnimatedBackground = () => {
  return (
    <div className="animated-background">
      <ul className="circles">
        {Array.from({ length: 10 }).map((_, i) => (
          <li key={i}></li>
        ))}
      </ul>
    </div>
  );
};

export default AnimatedBackground;
